// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"b02c2897","162":"506c4d61","286":"40644715","368":"eb0d34e1","377":"ff12314c","481":"c6fff668","642":"6d7f7916","684":"a11a9222","940":"da1f0171"}[chunkId] + ".chunk.js";
};